(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const setHeaderHeight = () => {
    const header = $('.lcl-header');
    const banner = $('.lcl-banner');
    const headerH = header ? header.offsetHeight : 87;
    const bannerH = banner ? banner.offsetHeight : 0;
    document.documentElement.style.setProperty('--lcl-banner-height', `${bannerH}px`);
    document.documentElement.style.setProperty('--lcl-chrome-height', `${headerH + bannerH}px`);
  };

  const initNav = () => {
    const header = $('.lcl-header');
    if (!header) return;
    const toggle = $('.lcl-header__toggle', header);
    const nav = $('.lcl-header__nav', header);
    if (!toggle || !nav) return;

    const close = () => {
      header.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('lcl-nav-open');
    };

    toggle.addEventListener('click', () => {
      const open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('lcl-nav-open', open);
    });

    nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });
  };

  const initGallery = () => {
    $$('[data-lcl-gallery]').forEach((gallery) => {
      const main = $('[data-lcl-gallery-main]', gallery);
      const thumbs = $$('[data-lcl-gallery-thumb]', gallery);
      if (!main || !thumbs.length) return;

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', (event) => {
          event.preventDefault();
          const src = thumb.getAttribute('data-src') || thumb.getAttribute('href');
          const img = $('img', main);
          if (src && img) {
            img.src = src;
            img.srcset = thumb.getAttribute('data-srcset') || src;
          }
          thumbs.forEach((item) => item.removeAttribute('aria-current'));
          thumb.setAttribute('aria-current', 'true');
          gallery.setAttribute('data-index', String(index));
        });
      });
    });
  };

  const initCallouts = () => {
    $$('[data-lcl-callouts]').forEach((root) => {
      if (root.dataset.lclCalloutsReady) return;
      const track = $('.lcl-callouts__track', root);
      const frame = $('.lcl-callouts__frame', root);
      const dotsWrap = $('[data-lcl-callout-dots]', root);
      const originals = $$('[data-lcl-callout]', track);
      if (originals.length < 2 || !track || !frame) return;

      root.dataset.lclCalloutsReady = '1';
      const count = originals.length;
      originals.forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('data-lcl-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
      originals
        .slice()
        .reverse()
        .forEach((slide) => {
          const clone = slide.cloneNode(true);
          clone.setAttribute('data-lcl-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          track.insertBefore(clone, track.firstChild);
        });

      let index = count;
      let token = 0;
      let drag = null;
      let dragged = false;
      let moving = false;
      let wheelX = null;
      let wheelTimer = 0;
      const decoded = new WeakSet();
      const decoding = new WeakMap();
      const keptBitmaps = [];

      const slideWidth = () => frame.clientWidth || 1;

      const warm = (img) => {
        if (!img || decoded.has(img)) return Promise.resolve();
        const pending = decoding.get(img);
        if (pending) return pending;
        img.loading = 'eager';
        img.decoding = 'sync';
        if ('fetchPriority' in img) img.fetchPriority = 'high';
        const task = (typeof img.decode === 'function' ? img.decode() : Promise.resolve())
          .then(() => {
            decoded.add(img);
            if (typeof createImageBitmap === 'function' && img.naturalWidth) {
              createImageBitmap(img).then((bitmap) => keptBitmaps.push(bitmap)).catch(() => {});
            }
          })
          .catch(() => {
            decoded.add(img);
          });
        decoding.set(img, task);
        return task;
      };

      $$('img', track).forEach((img) => warm(img));

      const place = (i, animate, extraPx = 0) => {
        const motion = Boolean(animate && !prefersReducedMotion());
        if (moving !== motion) {
          track.style.transition = motion ? 'transform 0.45s ease' : 'none';
          if (!motion) void track.offsetWidth;
          moving = motion;
        }
        const shift = extraPx ? `calc(${-i * 100}% + ${extraPx}px)` : `${-i * 100}%`;
        track.style.transform = `translate3d(${shift}, 0, 0)`;
      };

      const realIndex = () => {
        let n = index % count;
        if (n < 0) n += count;
        return n;
      };

      const paintDots = () => {
        if (!dotsWrap) return;
        const current = realIndex();
        $$('button', dotsWrap).forEach((dot, i) => {
          if (i === current) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      const wrapIndex = () => {
        let next = index;
        while (next < count) next += count;
        while (next >= count * 2) next -= count;
        if (next === index) return;
        index = next;
        place(index, false);
      };

      const go = (next) => {
        if (index < count || index >= count * 2) {
          let base = index;
          while (base < count) base += count;
          while (base >= count * 2) base -= count;
          if (base !== index) {
            next -= index - base;
            index = base;
            place(index, false);
          }
        }
        const my = ++token;
        index = next;
        const img = track.children[index] && track.children[index].querySelector('img');
        const start = () => {
          if (my !== token) return;
          place(index, true);
          paintDots();
          const finish = (event) => {
            if (event && event.target !== track) return;
            if (my !== token) return;
            track.removeEventListener('transitionend', finish);
            wrapIndex();
          };
          if (prefersReducedMotion()) {
            wrapIndex();
            return;
          }
          track.addEventListener('transitionend', finish);
          window.setTimeout(() => finish({ target: track }), 520);
        };
        if (img && !decoded.has(img)) {
          let started = false;
          const run = () => {
            if (started || my !== token) return;
            started = true;
            start();
          };
          warm(img).then(run, run);
          window.setTimeout(run, 150);
          return;
        }
        start();
      };

      if (dotsWrap) {
        dotsWrap.innerHTML = originals
          .map((_, i) => `<button type="button" class="lcl-dots__dot" aria-label="Slide ${i + 1}"></button>`)
          .join('');
        $$('button', dotsWrap).forEach((dot, i) => {
          dot.addEventListener('click', () => {
            let delta = i - realIndex();
            if (delta > count / 2) delta -= count;
            if (delta < -count / 2) delta += count;
            go(index + delta);
          });
        });
      }

      root.addEventListener('click', (event) => {
        if (dragged) {
          dragged = false;
          event.preventDefault();
          return;
        }
        if (event.target.closest('[data-lcl-callout-dots]')) return;
        if (event.target.closest('[data-lcl-callout-prev]')) {
          go(index - 1);
          return;
        }
        if (event.target.closest('[data-lcl-callout-next]') || frame.contains(event.target)) go(index + 1);
      });

      frame.addEventListener('pointerdown', (event) => {
        if (event.target.closest('[data-lcl-callout-dots]')) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        token += 1;
        drag = {
          id: event.pointerId,
          startX: event.clientX,
          moved: false,
        };
        try {
          frame.setPointerCapture(event.pointerId);
        } catch (error) {}
        place(index, false);
      });

      frame.addEventListener('pointermove', (event) => {
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.startX;
        if (Math.abs(dx) > 4) drag.moved = true;
        place(index, false, dx);
      });

      const endDrag = (event) => {
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.startX;
        const moved = drag.moved;
        drag = null;
        if (typeof frame.hasPointerCapture === 'function' && frame.hasPointerCapture(event.pointerId)) {
          frame.releasePointerCapture(event.pointerId);
        }
        if (event.target.closest('[data-lcl-callout-dots]')) return;
        if (!moved) {
          dragged = true;
          go(index + 1);
          return;
        }
        dragged = true;
        const width = slideWidth();
        let hops = Math.round(-dx / width);
        if (hops === 0 && dx <= -36) hops = 1;
        if (hops === 0 && dx >= 36) hops = -1;
        go(index + hops);
      };

      frame.addEventListener('pointerup', endDrag);
      frame.addEventListener('pointercancel', endDrag);

      frame.addEventListener(
        'wheel',
        (event) => {
          const absX = Math.abs(event.deltaX);
          const absY = Math.abs(event.deltaY);
          if (absX < 1 || absX <= absY) return;
          event.preventDefault();
          const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? slideWidth() : 1;
          if (wheelX == null) wheelX = 0;
          token += 1;
          wheelX -= event.deltaX * unit;
          place(index, false, wheelX);
          window.clearTimeout(wheelTimer);
          wheelTimer = window.setTimeout(() => {
            const dx = wheelX;
            wheelX = null;
            const width = slideWidth();
            let hops = Math.round(-dx / width);
            if (hops === 0 && dx <= -36) hops = 1;
            if (hops === 0 && dx >= 36) hops = -1;
            go(index + hops);
          }, 90);
        },
        { passive: false }
      );

      place(index, false);
      paintDots();
      window.addEventListener('resize', () => place(index, false));
    });
  };

  const initReviews = () => {
    $$('[data-lcl-reviews]').forEach((root) => {
      if (root.dataset.lclReviewsReady) return;
      const viewport = $('[data-lcl-reviews-viewport]', root);
      const track = $('[data-lcl-reviews-track]', root);
      if (!viewport || !track) return;

      const originals = $$('.lcl-review', track).filter((slide) => !slide.hasAttribute('data-lcl-clone'));
      if (originals.length < 2) return;
      root.dataset.lclReviewsReady = '1';

      const count = originals.length;
      originals.forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('data-lcl-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
      originals
        .slice()
        .reverse()
        .forEach((slide) => {
          const clone = slide.cloneNode(true);
          clone.setAttribute('data-lcl-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          track.insertBefore(clone, track.firstChild);
        });

      const slides = () => $$('.lcl-review', track);
      let index = count;
      let token = 0;
      let drag = null;
      let wheelX = null;
      let wheelTimer = 0;
      let moving = false;

      const metrics = () => {
        const list = slides();
        const first = list[0];
        const second = list[1];
        const width = first ? first.getBoundingClientRect().width : 320;
        const gap = first && second ? second.getBoundingClientRect().left - first.getBoundingClientRect().right : 0;
        return { width, step: width + Math.max(0, gap) };
      };

      const offsetFor = (i) => {
        const { width, step } = metrics();
        return (viewport.clientWidth - width) / 2 - i * step;
      };

      const place = (x, animate) => {
        const motion = Boolean(animate && !prefersReducedMotion());
        if (moving !== motion) {
          track.style.transition = motion ? 'transform 0.55s cubic-bezier(0.22, 1, 0.36, 1)' : 'none';
        if (!motion) void track.offsetWidth;
        moving = motion;
      }
      viewport.scrollLeft = 0;
      track.style.transform = `translate3d(${x}px, 0, 0)`;
    };

      const nearestIndex = (x) => {
        const { width, step } = metrics();
        const center = (viewport.clientWidth - width) / 2;
        return Math.round((center - x) / step);
      };

      const wrapIndex = () => {
        let next = index;
        while (next < count) next += count;
        while (next >= count * 2) next -= count;
        if (next === index) return;
        index = next;
        place(offsetFor(index), false);
      };

      const go = (next) => {
        const my = ++token;
        index = next;
        place(offsetFor(index), true);
        const finish = (event) => {
          if (event && event.target !== track) return;
          if (my !== token) return;
          track.removeEventListener('transitionend', finish);
          wrapIndex();
        };
        if (prefersReducedMotion()) {
          wrapIndex();
          return;
        }
        track.addEventListener('transitionend', finish);
        window.setTimeout(() => finish({ target: track }), 620);
      };

      $('[data-lcl-reviews-prev]', root)?.addEventListener('click', () => go(index - 1));
      $('[data-lcl-reviews-next]', root)?.addEventListener('click', () => go(index + 1));

      viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        token += 1;
        drag = {
          id: event.pointerId,
          startX: event.clientX,
          startTx: offsetFor(index),
          moved: false,
        };
        viewport.setPointerCapture(event.pointerId);
        place(drag.startTx, false);
      });

      viewport.addEventListener('pointermove', (event) => {
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.startX;
        if (Math.abs(dx) > 4) drag.moved = true;
        place(drag.startTx + dx, false);
      });

      const endDrag = (event) => {
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.startX;
        const moved = drag.moved;
        const x = drag.startTx + dx;
        drag = null;
        if (!moved) {
          place(offsetFor(index), true);
          return;
        }
        let nearest = nearestIndex(x);
        if (nearest === index && dx <= -36) nearest = index + 1;
        if (nearest === index && dx >= 36) nearest = index - 1;
        go(nearest);
      };

      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);

      viewport.addEventListener(
        'wheel',
        (event) => {
          const absX = Math.abs(event.deltaX);
          const absY = Math.abs(event.deltaY);
          if (absX < 1 || absX <= absY) return;
          event.preventDefault();
          const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? viewport.clientWidth : 1;
          if (wheelX == null) wheelX = offsetFor(index);
          token += 1;
          wheelX -= event.deltaX * unit;
          place(wheelX, false);
          window.clearTimeout(wheelTimer);
          wheelTimer = window.setTimeout(() => {
            const x = wheelX;
            wheelX = null;
            go(nearestIndex(x));
          }, 90);
        },
        { passive: false }
      );

      place(offsetFor(index), false);
      requestAnimationFrame(() => place(offsetFor(index), false));
      window.addEventListener('resize', () => {
        wheelX = null;
        place(offsetFor(index), false);
      });
    });
  };

  const prefersReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const easePower2InOut = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);
  const easePower2Out = (t) => 1 - (1 - t) * (1 - t);

  const drawSquiggle = (svg, duration, ease) => {
    if (!svg || svg.dataset.lclSquiggleReady) return;
    const path = svg.querySelector('path');
    if (!path || typeof path.getTotalLength !== 'function') return;

    const length = Math.ceil(path.getTotalLength());
    if (!length) return;

    svg.dataset.lclSquiggleReady = '1';
    svg.classList.add('is-ready');

    if (prefersReducedMotion()) {
      path.style.strokeDasharray = '';
      path.style.strokeDashoffset = '';
      return;
    }

    path.style.strokeDasharray = String(length);
    path.style.strokeDashoffset = String(length);

    const start = performance.now();
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      path.style.strokeDashoffset = String(length * (1 - ease(t)));
      if (t < 1) {
        requestAnimationFrame(tick);
      } else {
        path.style.strokeDasharray = '';
        path.style.strokeDashoffset = '';
      }
    };
    requestAnimationFrame(tick);
  };

  const initSquiggles = () => {
    $$('[data-lcl-squiggle]').forEach((svg) => {
      if (svg.dataset.lclSquiggleReady) return;

      if (svg.getAttribute('data-lcl-squiggle') === 'hero') {
        const hero = svg.closest('.lcl-hero');
        const img = hero ? $('img', hero) : null;
        const start = () => drawSquiggle(svg, 2000, easePower2InOut);
        if (!img) {
          start();
          return;
        }
        if (img.complete) start();
        else img.addEventListener('load', start, { once: true });
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            drawSquiggle(svg, 1750, easePower2Out);
            observer.unobserve(svg);
          });
        },
        { rootMargin: '0px 0px -25% 0px', threshold: 0 }
      );
      observer.observe(svg);
    });
  };

  const initFaqFilter = () => {
    $$('[data-lcl-faq]').forEach((root) => {
      const buttons = $$('[data-lcl-faq-tab]', root);
      const groups = $$('[data-lcl-faq-group]', root);
      if (!buttons.length) return;

      const activate = (slug) => {
        buttons.forEach((btn) => {
          btn.setAttribute('aria-selected', btn.getAttribute('data-lcl-faq-tab') === slug ? 'true' : 'false');
        });
        groups.forEach((group) => {
          group.hidden = group.getAttribute('data-lcl-faq-group') !== slug;
        });
      };

      buttons.forEach((btn) => {
        btn.addEventListener('click', () => activate(btn.getAttribute('data-lcl-faq-tab')));
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    setHeaderHeight();
    initNav();
    initGallery();
    initCallouts();
    initReviews();
    initFaqFilter();
    initSquiggles();
    window.addEventListener('resize', setHeaderHeight);
  });

  document.addEventListener('shopify:section:load', () => {
    setHeaderHeight();
    initNav();
    initGallery();
    initCallouts();
    initReviews();
    initFaqFilter();
    initSquiggles();
  });
})();
